import { Suspense } from 'react';

import { AnalyticsBrowser } from '@segment/analytics-next';

import { useSessionReplay } from 'contexts/analytics/useSessionReplay';
import useIsSessionReplayEnabled from 'services/features/useIsSessionReplayEnabled';

type SessionReplayProps = {
  analyticsBrowser: AnalyticsBrowser | null;
};

const SessionReplayGate = ({ analyticsBrowser }: SessionReplayProps) => {
  const { isEnabled } = useIsSessionReplayEnabled();
  useSessionReplay(analyticsBrowser, isEnabled);
  return null;
};

export const SessionReplay = (props: SessionReplayProps) => (
  <Suspense fallback={null}>
    <SessionReplayGate {...props} />
  </Suspense>
);
